import * as Yup from "yup";

// Valores iniciales
export function initialValuesFour(scene) {
  return {
    ModFourTitle: scene?.ModFourTitle || "",
    ModFourSubtitle: scene?.ModFourSubtitle || "",
    ModFourUsescases: scene?.ModFourUsescases || [
      { title: "", description: "" },
    ], // Array inicial para categorías
    ModFourVideo: scene?.ModFourVideo?.length ? scene.ModFourVideo : [""], //ModFour url video
  };
}

// Esquema de validación
export function validationSchemaFour() {
  return Yup.object({
    ModFourTitle: Yup.string().required("El título es obligatorio"),
    ModFourSubtitle: Yup.string(),
    ModFourUsescases: Yup.array()
      .of(
        Yup.object().shape({
          title: Yup.string().required(
            "El título de la categoría es obligatorio",
          ),
          description: Yup.string(),
        }),
      )
      .min(1, "Debes añadir al menos una categoría"), // Valida que haya al menos una categoría
    ModFourVideo: Yup.array().of(
      Yup.string().url("Debe ser URL válida"), // Validación para que los videos sean URLs
    ),
  });
}
